// -------------ea-poster1 --------------------
gsap.registerPlugin(ScrollTrigger);

gsap.to(".big-text1 h2", {
  transform: "translateX(-100%)",
  scrollTrigger: {
    trigger: ".big-text1",
    scroller: "body",
    start: "top 70%",
    end: "top 10%",
    toggleActions: "restart none none reverse",
    scrub: 3,
  },
});

// -------------ea-poster1 --------------------

// ------- cart drawer suggestion box ------(removed from XD)----

// document.addEventListener("DOMContentLoaded", function () {
//     const cartDrawer = document.querySelector(".cart-drawer");

//     if (!cartDrawer) {
//         console.warn("Cart drawer element not found.");
//         return;
//     }

//     function activateCart() {
//         const cartTab = cartDrawer.querySelector(".cart-tab");
//         const suggestionsTab = cartDrawer.querySelector(".suggestions-tab");
//         const cartDrawerItems = cartDrawer.querySelector("cart-drawer-items");
//         const suggestionsBox = cartDrawer.querySelector(".suggestions-content");

//         if (cartTab) cartTab.style.opacity = "1";
//         if (suggestionsTab) suggestionsTab.style.opacity = "0.65";
//         if (cartDrawerItems) cartDrawerItems.style.display = "block";
//         if (suggestionsBox) suggestionsBox.style.display = "none";
//     }

//     function activateSuggestions() {
//         const cartTab = cartDrawer.querySelector(".cart-tab");
//         const suggestionsTab = cartDrawer.querySelector(".suggestions-tab");
//         const cartDrawerItems = cartDrawer.querySelector("cart-drawer-items");
//         const suggestionsBox = cartDrawer.querySelector(".suggestions-content");

//         if (cartTab) cartTab.style.opacity = "0.65";
//         if (suggestionsTab) suggestionsTab.style.opacity = "1";
//         if (cartDrawerItems) cartDrawerItems.style.display = "none";
//         if (suggestionsBox) suggestionsBox.style.display = "block";
//     }

//     function updateFooterVisibility() {
//         const cartDrawerFooter = cartDrawer.querySelector(".drawer__footer");
//         const cartDrawerItems = cartDrawer.querySelector("cart-drawer-items"); // Re-select cart items
//         const isEmpty = cartDrawerItems && cartDrawerItems.classList.contains('is-empty');

//         if (cartDrawerFooter) {
//             if (isEmpty) {
//                 cartDrawerFooter.style.display = "none";
//             } else {
//                 cartDrawerFooter.style.display = "block"; // Or whatever the default display is (e.g., "flex", "grid")
//             }
//         }
//     }

//     activateCart();
//     updateFooterVisibility(); // Initial check on page load

//     // Event delegation
//     cartDrawer.addEventListener("click", function (event) {
//         if (event.target.classList.contains("cart-tab")) {
//             activateCart();
//         } else if (event.target.classList.contains("suggestions-tab")) {
//             activateSuggestions();
//         }
//     });

//     // Listen for cart updates using a MutationObserver
//     const observer = new MutationObserver(updateFooterVisibility);
//     observer.observe(cartDrawer, {
//         childList: true,
//         subtree: true,
//         attributes: true,
//         attributeFilter: ['class']
//     });
// });

// ------- cart drawer suggestion box ----------

// --------- Draggable Scroll JS ---------
function enableLeftClickDragScroll(container) {
  if (!container) return;

  let isDragging = false;
  let dragStarted = false;
  let startX = 0;
  let scrollStart = 0;
  const dragThreshold = 5;
  const scrollSpeedFactor = 0.9; // Lower values = slower scrolling

  container.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    isDragging = true;
    dragStarted = false;
    startX = e.pageX;
    scrollStart = container.scrollLeft;
    container.classList.add("is-dragging");
    e.preventDefault();
  });

  container.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    const deltaX = e.pageX - startX;

    if (!dragStarted && Math.abs(deltaX) > dragThreshold) {
      dragStarted = true;
    }

    if (dragStarted) {
      container.scrollLeft = scrollStart - deltaX * scrollSpeedFactor;
    }
  });

  container.addEventListener("mouseup", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("mouseleave", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("click", (e) => {
    if (dragStarted) {
      e.preventDefault();
      e.stopPropagation();
      dragStarted = false;
    }
  });

  container.classList.add("is-draggable");
}


function waitForElementAndInit(selector) {
  // Initialize any that already exist
  document.querySelectorAll(selector).forEach(el => {
    if (!el._dragInitialized) {
      enableLeftClickDragScroll(el);
      el._dragInitialized = true;
    }
  });

  // Observe future additions
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches(selector) && !node._dragInitialized) {
          enableLeftClickDragScroll(node);
          node._dragInitialized = true;
        }

        // Check descendants too
        node.querySelectorAll?.(selector)?.forEach((el) => {
          if (!el._dragInitialized) {
            enableLeftClickDragScroll(el);
            el._dragInitialized = true;
          }
        });
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // ===============================================
  // ADD CLASS OR ID OF CONTAINER TO SCROLL [ DEV-03 ]
  // ===============================================
  const scrollSelectors = [".grid .grid__item .card-wrapper .card__inner .card__media", ".search-product-recommendations .product-grid"];

  scrollSelectors.forEach(selector => {
    waitForElementAndInit(selector);
  });
});

// --------- Draggable JS ---------


// --- smooth scroll --------------

// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});

// Update ScrollTrigger on Lenis scroll
lenis.on("scroll", ScrollTrigger.update);

// Integrate Lenis's request animation frame with GSAP's ticker
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

// Disable GSAP's lag smoothing to match Lenis
gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------

// --------- header logo animation --------------------

document.addEventListener("DOMContentLoaded", function () {
  const logo = document.querySelector(".logo");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 50) {
      logo.classList.remove("not-scrolled"); // Remove scroll-up state
      logo.classList.add("scrolled"); // Apply scroll-down effect
    } else {
      logo.classList.remove("scrolled"); // Remove scroll-down effect
      logo.classList.add("not-scrolled"); // Apply scroll-up effect
    }
  });
});

// --------- header logo animation --------------------

// ---------------- mobile menu --------------------------
document.addEventListener("DOMContentLoaded", function () {
  const menuButton = document.querySelector(".mob_menu");
  const menuData = document.querySelector(".mob-menu-data");
  const navbar = document.querySelector(".navbar");

  menuButton.addEventListener("click", function () {
    // Toggle menu classes (all pages)
    this.classList.toggle("active");
    menuData.classList.toggle("active");

  
    if (location.pathname === "/") {

      if (menuData.classList.contains("active")) {
        // Menu OPEN
        navbar.classList.add("bg_change");
        navbar.classList.add("nav-bg_white");
        navbar.setAttribute("data-page", "notHome");

      } else {
        // Menu CLOSED
        navbar.classList.remove("bg_change");

     
        if (window.scrollY < 10) {
          navbar.classList.remove("nav-bg_white");
        }

        navbar.setAttribute("data-page", "home");
      }

    }
  });
});


// ---------------- mobile menu --------------------------

// ---------- product page marquee top mobile view ------

document.addEventListener("DOMContentLoaded", function () {
  function applyMarqueeStyle() {
    const isProductPage = window.location.pathname.includes("/products/");
    const isMobileView = window.innerWidth <= 950;
    const marqueeElement = document.querySelector(
      ".shopify-section .marquee-custom"
    );

    if (isProductPage && isMobileView && marqueeElement) {
      marqueeElement.style.top = "14vw";
      marqueeElement.style.bottom = "unset";
    }
  }

  // Run function on page load
  applyMarqueeStyle();

  // Run again if window resizes (ensures it works on screen resize)
  window.addEventListener("resize", applyMarqueeStyle);

  // Run again when Shopify dynamically loads sections (AJAX navigation fix)
  document.addEventListener("shopify:section:load", applyMarqueeStyle);
});

// ---------- product page marquee top mobile view ------

// ------------- collection page grid change---------------------

// document.addEventListener("DOMContentLoaded", function () {
//   const gridOptions = document.querySelectorAll(
//     ".grid-option:not(.mobile-toggle)"
//   );
//   const mobileToggle = document.querySelector(".mobile-toggle");
//   const gridContainer = document.querySelector(".d-collection .grid"); // Apply ONLY inside .d-collection

//   // Grid Width Settings
//   const gridSettings = {
//     3: { width: "33.20%", maxWidth: "33.20%" },
//     4: { width: "25%", maxWidth: "25%" },
//     6: { width: "16.60%", maxWidth: "16.60%" },
//     2: { width: "50%", maxWidth: "50%" },
//     1: { width: "100%", maxWidth: "100%" },
//   };

//   let currentGridValue = window.innerWidth > 950 ? "3" : "2"; // Default value

//   function setGrid(gridValue) {
//     let gridItems = document.querySelectorAll(".d-collection .grid__item"); // Only inside .d-collection
//     gridItems.forEach((item) => {
//       item.style.width = gridSettings[gridValue].width;
//       item.style.maxWidth = gridSettings[gridValue].maxWidth;
//       item.style.opacity = "1"; // Ensure they are visible instantly
//       item.style.transition = "width 0.3s ease-in-out"; // Smooth transition
//     });
//     currentGridValue = gridValue; // Store current selection
//   }

//   function updateGrid(event) {
//     event.preventDefault();
//     gridOptions.forEach((option) => option.classList.remove("active"));
//     this.classList.add("active");
//     setGrid(this.dataset.grid);
//   }

//   // Attach event listeners to grid options
//   gridOptions.forEach((option) => option.addEventListener("click", updateGrid));

//   // Mobile Toggle Logic
//   let mobileGridState = "2";
//   mobileToggle.addEventListener("click", function (event) {
//     event.preventDefault();
//     mobileGridState = mobileGridState === "2" ? "1" : "2";
//     setGrid(mobileGridState);
//   });

//   // Initial setup
//   setGrid(currentGridValue);
//   document
//     .querySelector(`.grid-option[data-grid="${currentGridValue}"]`)
//     ?.classList.add("active");

//   // Observe for new products appearing dynamically and apply the grid instantly
//   const observer = new MutationObserver(() => {
//     setGrid(currentGridValue); // Apply width immediately to new elements inside .d-collection
//   });
//   observer.observe(gridContainer, { childList: true, subtree: true });

//   // Scroll Reveal Fix using IntersectionObserver (but apply width only inside .d-collection)
//   const revealObserver = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting && entry.target.closest(".d-collection")) {
//           entry.target.style.opacity = "1"; // Ensure it's visible without delay
//           setGrid(currentGridValue); // Apply width instantly
//         }
//       });
//     },
//     { rootMargin: "200px" }
//   );

//   // Observe existing grid items inside .d-collection and future ones
//   function observeGridItems() {
//     document.querySelectorAll(".d-collection .grid__item").forEach((item) => {
//       revealObserver.observe(item);
//       item.style.opacity = "1"; // Apply instantly without delay
//     });
//   }
//   observeGridItems(); // Run on load

//   // Detect Shopify AJAX events (pagination, filters, etc.)
//   document.addEventListener("shopify:section:load", () => {
//     setGrid(currentGridValue);
//     observeGridItems(); // Ensure new items inside .d-collection are observed instantly
//   });

//   // **🔥 Ajaxinate Support for Infinite Scroll**
//   if (typeof Ajaxinate !== "undefined") {
//     new Ajaxinate({
//       pagination: "#AjaxinatePagination",
//       method: "scroll",
//       container: "#AjaxinateLoop",
//       offset: 0,
//       loadingText: "Loading...",
//       callback: () => {
//         setGrid(currentGridValue); // Apply grid changes to newly loaded items inside .d-collection
//         observeGridItems();
//       },
//     });
//   }
// });

document.addEventListener('DOMContentLoaded', () => {
  const grid = document.getElementById('product-grid');
  if (!grid) return;

  const buttons = document.querySelectorAll('.grid-buttons li');
  const mobileToggle = document.querySelector('.grid-buttons .grid-toggle');

  // helper to remove grid-* classes
  function resetGridClasses() {
    grid.className = grid.className
      .split(' ')
      .filter(cls => !/^grid-\d+$/.test(cls))
      .join(' ');
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {

      // 🔹 MOBILE TOGGLE
      if (btn === mobileToggle) {
        const current = Number(btn.dataset.columns);
        const next = current === 2 ? 1 : 2;

        btn.dataset.columns = next;

        resetGridClasses();
        grid.classList.add(`grid-${next}`);

        btn.classList.toggle('active', next === 2);
        return;
      }

      // 🔹 DESKTOP BUTTONS
      buttons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      resetGridClasses();
      grid.classList.add(`grid-${btn.dataset.columns}`);
    });
  });
});

// ------------- collection page grid change---------------------

// ------- size chart and product name z-index problem --mob---

document.addEventListener("DOMContentLoaded", function () {
  function updateZIndex() {
    const sizeBox = document.querySelector(".size-box");
    const mobPriceName = document.querySelector(".mob-price-name");

    if (!sizeBox) return;

    const zIndexValue = sizeBox.classList.contains("size-box-active")
      ? "0"
      : "";

    if (mobPriceName) mobPriceName.style.zIndex = zIndexValue;
  }

  updateZIndex();

  const observer = new MutationObserver(updateZIndex);
  const sizeBoxElement = document.querySelector(".size-box");

  if (sizeBoxElement) {
    observer.observe(sizeBoxElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  document.body.addEventListener("click", updateZIndex);
});

// ------- size chart and product name z-index problem --mob---

// -------------- search box container ---------------------

function opensearchbox() {
  const searchData = document.querySelector(".search-container-cust");
  searchData.classList.toggle("active");
}

// -------------- search box container --------end-------------

// ------- navbar scroll and bg chnage - mobile only------

document.addEventListener("DOMContentLoaded", function () {
  const navbar = document.querySelector(".navbar");

  function handleScroll() {
    if (window.innerWidth <= 950) {
      // Apply only for mobile view (<= 950px)
      if(navbar.getAttribute("data-page")!="home"){
        return
      }
      if (window.scrollY > 50) {
        navbar.style.transition = "background-color 0.4s ease-in-out";
        navbar.classList.add('nav-bg_white');
        navbar.style.backgroundColor = "transparent";
      } else {
        navbar.style.backgroundColor = "transparent";

        navbar.classList.remove('nav-bg_white');

      }
    } else {
      navbar.style.backgroundColor = ""; // Reset for desktop
    }
  }

  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleScroll); // Recheck on resize
});

document.addEventListener("DOMContentLoaded", function () {
  const navbar = document.querySelector(".navbar");
  let lastScrollY = window.scrollY;

  function handleScroll() {
    if (window.innerWidth > 950) {
      navbar.style.backgroundColor = "";
      navbar.classList.remove("nav-bg_white");
      return;
    }

    if (navbar.getAttribute("data-page") !== "home") return;

    const currentScrollY = window.scrollY;
    navbar.style.transition = "background-color 0.1s ease-in-out";

    // 🔝 Near top
    if (currentScrollY < 50) {
      navbar.style.backgroundColor = "transparent";
      
      navbar.classList.remove("bg_change");
      navbar.classList.remove("nav-bg_white");
    }
    // ⬆ Scroll UP
    else if (currentScrollY < lastScrollY) {
      navbar.style.backgroundColor = "#fff";
      navbar.classList.add("bg_change");
      
    }
    // ⬇ Scroll DOWN
    else {
      navbar.classList.remove("bg_change");
      navbar.classList.add("nav-bg_white");
      navbar.style.backgroundColor = "transparent";
    }

    lastScrollY = currentScrollY;
  }

  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleScroll);
});

// document.addEventListener("DOMContentLoaded", function () {
//   const navbar = document.querySelector(".navbar");
//   let lastScrollY = window.scrollY;

//   function handleScroll() {

//     if (navbar.getAttribute("data-page") !== "home") return;

//     const currentScrollY = window.scrollY;
//     navbar.style.transition = "background-color 0.1s ease-in-out";

//     // 🔝 Near top
//     if (currentScrollY < 50) {
//       navbar.style.backgroundColor = "transparent";
//       navbar.classList.remove("bg_change");
//       navbar.classList.remove("nav-bg_white");
//     }
//     // ⬆ Scroll UP
//     else if (currentScrollY < lastScrollY) {
//       navbar.style.backgroundColor = "#fff";
//       navbar.classList.add("bg_change");
//       navbar.classList.remove("nav-bg_white");
//     }
//     // ⬇ Scroll DOWN
//     else {
//       navbar.classList.remove("bg_change");
//       navbar.classList.add("nav-bg_white");
//       navbar.style.backgroundColor = "transparent";
//     }

//     lastScrollY = currentScrollY;
//   }

//   window.addEventListener("scroll", handleScroll);
// });



// ------- navbar scroll and bg chnage - mobile only------

// ----- marquee hide in footer - mobile view ------

// document.addEventListener("DOMContentLoaded", () => {
//   const marquee = document.querySelector(".marquee-custom");
//   const footer = document.querySelector(".footer-box");

//   if (marquee && footer) {
//     new IntersectionObserver(
//       ([entry]) => {
//         if (window.innerWidth <= 950) {
//           marquee.style.opacity = entry.isIntersecting ? "0" : "1";
//           marquee.style.transition = "opacity 0.5s ease-in-out";
//         }
//       },
//       { threshold: 0.1 }
//     ).observe(footer);
//   }
// });

// ----- marquee hide in footer - mobile view ------

// -------- close btn marquee --------------

function closemq() {
  const marqueecl = document.querySelector(".marquee-custom");
  marqueecl.classList.toggle("close");
}

// -------- close btn marquee --------------


// ========================= Quick Add Cart Drawer Function========================================

document.addEventListener("click", function (event) {
  // Check if the clicked element has the class .quick-add-btn
  const clickedElement = event.target;
  if(clickedElement.nodeName == "svg" || clickedElement.nodeName == "path" || clickedElement.nodeName == "g"){
    let mainEl = clickedElement.closest('.quick-add-btn');
     quickAddCartDrawer(mainEl);
    return
  }
  // ============== If Clicked on Quick Add Btn Then call Function ===============
  if (clickedElement.classList.contains("quick-add-btn")) {
    quickAddCartDrawer(clickedElement);
  }
});

function quickAddCartDrawer(clickedElemrnt) {
  const productId = clickedElemrnt.getAttribute("data-product-id");
  const variantId = clickedElemrnt.getAttribute("data-variant-id");
  const cartDrawer = document.querySelector(".drawer__cart-items-wrapper");
  // Make sure the product ID and variant ID exist
  if (!productId || !variantId) {
    console.error("Product ID or Variant ID is missing.");
    return;
  }

  // Add the product to the cart via Shopify AJAX API
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId, // Use the variant ID from the clicked button
      quantity: 1, // Adding 1 quantity
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to add item to cart");
      }
      return response.json();
    })
    .then((data) => {
      console.log("Added to cart:", data);
      // Optionally, update UI (like cart count, etc.)
      updateCartUI();
    })
    .catch((error) => {
      console.error("Error adding product to cart:", error);
    });
  // Function to update the cart UI (like cart count)
  function updateCartUI() {
    fetch("/cart")
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const updatedCartDrawer = doc.querySelector(
          ".drawer__cart-items-wrapper"
        );

        if (cartDrawer && updatedCartDrawer) {
          fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
              document.querySelector(".cart-count-bubble").textContent =
                data.item_count;
            });
          cartDrawer.innerHTML = updatedCartDrawer.innerHTML;
        }
      })
      .catch((error) => {
        console.error("Error updating cart UI:", error);
      });
  }
}
// ========================= Quick Add Cart Drawer Function [END]========================================

// ============= Marquee Close on sroll =============


// (function () {
//   'use strict';

//   var doc = document;
//   var body = doc.body;
//   var marquee = doc.querySelector('.cust_announcement_main .cover');
//   var navbar = doc.querySelector('.navbar');

//   if (!marquee || !navbar) return;

//   var lastKnownScrollY = 0;
//   var ticking = false;
//   var threshold = marquee.offsetHeight || 40;

//   function onScroll() {
//     lastKnownScrollY = window.pageYOffset || doc.documentElement.scrollTop;
//     requestTick();
//   }

//   function requestTick() {
//     if (!ticking) {
//       window.requestAnimationFrame(update);
//       ticking = true;
//     }
//   }

//   function update() {
//     if (lastKnownScrollY > threshold) {
//       if (!body.classList.contains('marquee-hidden')) {
//         body.classList.add('marquee-hidden');
//       }
//     } else {
//       body.classList.remove('marquee-hidden');
//     }
//     ticking = false;
//   }

//   // Scroll listener (PASSIVE → iOS safe)
//   window.addEventListener('scroll', onScroll, { passive: true });

//   // Recalculate on resize / orientation change
//   window.addEventListener('resize', function () {
//     threshold = marquee.offsetHeight || 40;
//     onScroll();
//   }, { passive: true });

//   // Initial state check
//   onScroll();
// })();



// ============= Marquee Close on sroll =============

document.addEventListener("scroll", function () {

  const triggerSections = document.querySelectorAll(".custom-featured-collection");
  const navbar = document.querySelector(".navbar");

  if (!triggerSections.length || !navbar) return;

  const scrollPosition = window.scrollY;
  const navbarHeight = navbar.offsetHeight;
  const navbarBottom = scrollPosition + navbarHeight;

  let isInsideAnySection = false;

  triggerSections.forEach(section => {
    const sectionTop = section.offsetTop;
    const sectionBottom = sectionTop + section.offsetHeight;

    if (navbarBottom >= sectionTop && scrollPosition <= sectionBottom) {
      isInsideAnySection = true;
    }
  });

  if (isInsideAnySection) {
    navbar.classList.add("svg_change");
  } else {
    navbar.classList.remove("svg_change");
  }

});





// pdp-and all page

document.addEventListener("DOMContentLoaded", function () {
  const navbar = document.querySelector(".navbar");

  if (!navbar) return;

  const page = navbar.getAttribute("data-page");

  // Mobile check
  function checkMobile() {
    if (window.innerWidth <= 950 && page !== "home") {
      navbar.classList.add("bg_change");
    } else {
      navbar.classList.remove("bg_change");
    }
  }

  // Initial check
  checkMobile();

  // Recheck on resize
  window.addEventListener("resize", checkMobile);
});


// SIZE-CHART
function toggleSizeChart(el){
  el.closest("product-info").querySelector(".size-box").classList.toggle('size-box-active')
}
function openSizeBox(){
  document.querySelector(".size-box").classList.remove('size-box-active')
}
// SIZE-CHART



// product scroll

(function () {
  
function initProductSliders(root = document) {
  if (typeof Swiper === 'undefined') return;

  const sliders = [];

  if (root.matches?.('[data-product-slider]')) {
    sliders.push(root);
  }

  sliders.push(
    ...(root.querySelectorAll?.('[data-product-slider]') || [])
  );

  sliders.forEach((slider) => {
    if (slider.swiper) return;

    
new Swiper(slider, {
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 0,
  centeredSlides: false,
  loop: false,
  autoplay: false,
  speed: 300,
  grabCursor: true,
  simulateTouch: true,
  allowTouchMove: true,
  followFinger: true,
  threshold: 5,
  resistance: true,
  resistanceRatio: 0.2,
  mousewheel: false,
  observer: true,
  observeParents: true
});

const swiperInstance = slider.swiper;

if (swiperInstance && !slider.dataset.wheelReady) {
  slider.dataset.wheelReady = 'true';

  let wheelLocked = false;
  let wheelDistance = 0;
  let wheelResetTimer;
  let wheelUnlockTimer;

  slider.addEventListener('wheel', (event) => {
    // Only horizontal laptop touchpad gestures
    if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) {
      return;
    }

    if (event.cancelable) {
      event.preventDefault();
    }

    if (wheelLocked) return;

    wheelDistance += event.deltaX;

    clearTimeout(wheelResetTimer);
    wheelResetTimer = setTimeout(() => {
      wheelDistance = 0;
    }, 180);

    if (Math.abs(wheelDistance) >= 40) {
      const direction = wheelDistance > 0 ? 1 : -1;

      if (direction > 0) {
        swiperInstance.slideNext();
      } else {
        swiperInstance.slidePrev();
      }

      wheelDistance = 0;
      wheelLocked = true;

      clearTimeout(wheelUnlockTimer);
      wheelUnlockTimer = setTimeout(() => {
        wheelLocked = false;
      }, 400);
    }
  }, { passive: false });
}

});
}


  function start() {
    initProductSliders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Shopify theme editor support.
  document.addEventListener('shopify:section:load', (event) => {
    initProductSliders(event.target);
  });

  // Dynamically loaded recommendation cards.
  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          initProductSliders(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();




